import styled from '@emotion/styled';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const DataBox = styled.span`
  text-align: right;
`;

export const StyledFontAwesomeIcon = styled(FontAwesomeIcon)`
  margin: 0 0.3rem;
`;
